export const cardList = {
    sz: [{
        type: '首诊卡',
        url: require('@/assets/img/doctor-detail/card/首诊卡.png')
    },
        {
            type: '首诊卡-选中',
            url: require('@/assets/img/doctor-detail/card/首诊卡-选中.png')
        }],
    hz: [
        {
            type: '会诊卡',
            url: require('@/assets/img/doctor-detail/card/会诊卡.png')
        },
        {
            type: '会诊卡-选中',
            url: require('@/assets/img/doctor-detail/card/会诊卡-选中.png')
        }
    ],
    tx: [
        {
            type: '图像卡',
            url: require('@/assets/img/doctor-detail/card/图像卡.png')
        },
        {
            type: '图像卡-选中',
            url: require('@/assets/img/doctor-detail/card/图像卡-选中.png')
        }
    ],
    fz: [
        {
            type: '复诊卡',
            url: require('@/assets/img/doctor-detail/card/复诊卡.png')
        },
        {
            type: '复诊卡-选中',
            url: require('@/assets/img/doctor-detail/card/复诊卡-选中.png')
        }
    ],
    sj: [
        {
            type: '设计单',
            url: require('@/assets/img/doctor-detail/card/设计单.png')
        },
        {
            type: '设计单-选中',
            url: require('@/assets/img/doctor-detail/card/设计单-选中.png')
        }
    ],
    gnkl: [
        {
            type: '快乐',
            url: require('@/assets/img/doctor-detail/card/快乐.png')
        },
        {
            type: '快乐-选中',
            url: require('@/assets/img/doctor-detail/card/快乐-选中.png')
        }
    ],
    yxkl: [
        {
            type: '快乐绿色',
            url: require('@/assets/img/doctor-detail/card/快乐绿色.png')
        },
        {
            type: '快乐绿色-选中',
            url: require('@/assets/img/doctor-detail/card/快乐绿色-选中.png')
        }
    ],
    jzq: [
        {
            type: '矫治器加工',
            url: require('@/assets/img/doctor-detail/card/矫治器加工.png')
        },
        {
            type: '矫治器加工-选中',
            url: require('@/assets/img/doctor-detail/card/矫治器加工-选中.png')
        }
    ]
}
